import { snakeCase } from 'lodash'
import { CalendarFilters } from 'screens/Calendar/types'

export const calendarKeys = {
  all: ['calendarItems'] as const,
  lists: () => [...calendarKeys.all, 'list'] as const,
  filters: (filters: CalendarFilters) => {
    const definedFilters: Record<string, string> = {}

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && (Array.isArray(value) ? value.length : true)) {
        definedFilters[snakeCase(key)] = String(value)
      }
    }

    return [...calendarKeys.lists(), { filters: definedFilters }] as const
  },
  unscheduled: (filters: CalendarFilters) => [...calendarKeys.filters(filters), 'unscheduled'] as const,
  detailAll: () => [...calendarKeys.all, 'detail'] as const,
  detail: (id: string) => [...calendarKeys.all, 'detail', id] as const,
  detailWithFilters: (id: string, filters: CalendarFilters) => {
    const definedFilters: Record<string, string> = {}

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && (Array.isArray(value) ? value.length : true)) {
        definedFilters[snakeCase(key)] = String(value)
      }
    }

    return [...calendarKeys.detail(id), { filters: definedFilters }] as const
  },
  dateRangeList: (filters: CalendarFilters, startDate: string, endDate: string) => {
    return [...calendarKeys.filters(filters), { dateRange: { startDate, endDate } }] as const
  },
}
